export const createSortParam = (field: string, desc = false) => {
  return `${field},${desc ? "desc" : "asc"}`;
};
